/** Turn a failed save into a message the team can act on. */
export function saveErrorMessage(error: any, fallback = "Save failed"): string {
  const msg = String(error?.message || "");
  const code = String(error?.code || "");
  const status = Number(error?.status || 0);
  if (status === 401 || code === "PGRST301" || /jwt|not authenticated|session/i.test(msg)) {
    return "Your session expired — sign in again; your changes are still in the form.";
  }
  return msg ? `${fallback}: ${msg}` : fallback;
}
